// Orders confirmed experience cards: explicit sortOrder override first
// (nulls last), then chronological epochExpTime (nulls last).
const LAST = Number.MAX_SAFE_INTEGER;

export function compareBySortOrderThenTime(a, b) {
  const ao = a.sortOrder ?? LAST;
  const bo = b.sortOrder ?? LAST;
  if (ao !== bo) return ao - bo;

  const at = a.epochExpTime ?? LAST;
  const bt = b.epochExpTime ?? LAST;
  if (at < bt) return -1;
  if (at > bt) return 1;
  return 0;
}
